// Generated by ScalaTS 0.8.2: https://scala-ts.github.io/scala-ts/

declare var exports: any;

export const nsPending = exports;

export const PendingInhabitant = 'Pending';

export type Pending = typeof PendingInhabitant;

export function isPending(v: any): v is Pending {
  return PendingInhabitant == v;
}

export type PendingSingleton = Pending;
